import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserHeaderComponent } from './user-header/user-header.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { UserRoutingModule } from './user-routing.module';
import { DxPopupModule, DxButtonModule, DxFormModule, DxSelectBoxModule, DxFileUploaderModule, DxLoadPanelModule, DxRadioGroupModule } from 'devextreme-angular';
import { UserLogoComponent } from './user-logo/user-logo.component';
import { UserLanguageComponent } from './user-language/user-language.component';
import { LocalizationModule } from '../@core/localization/localization.module';

@NgModule({
  imports: [
    CommonModule,
    UserRoutingModule,
    DxPopupModule,
    DxButtonModule,
    DxFormModule,
    FormsModule,
    DxSelectBoxModule,
    DxFileUploaderModule,
    DxLoadPanelModule,
    DxRadioGroupModule,
    LocalizationModule
  ],
  declarations: [UserHeaderComponent, UserProfileComponent, UserLogoComponent, UserLanguageComponent],
  exports: [UserHeaderComponent, UserProfileComponent, UserLogoComponent, UserLanguageComponent, LocalizationModule],
})

export class UserModule { }
